import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material';

import { QuickViewResponse } from './type';
import { STATUS_DEFINITIONS } from 'services/statusConfig';

interface Props {
  open: boolean;
  onClose: () => void;
  data?: QuickViewResponse;
  error?: string | null;
}

export const getStatusLabel = (statusId: number): string => {
  const status = STATUS_DEFINITIONS.find(({ id }) => id === statusId);

  if (!status) {
    return `Status ${statusId}`;
  }
  if (status.id === 8) {
    return 'Shipped To Store';
  }

  return status.key
    .replace(/KERRVILLE/g, 'PRODUCT_CARE')
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const QuickViewDialog = ({ open, onClose, data, error }: Props) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Store Service Item Summary</DialogTitle>

      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Overall service item count by status.
        </Typography>

        {error ? (
          <Typography color="error">{error}</Typography>
        ) : (
          <>
            <Box display="flex" justifyContent="space-between" mb={1}>
              <Typography
                variant="subtitle2"
                color="text.primary"
                fontWeight={600}
              >
                STATUS
              </Typography>

              <Typography
                variant="subtitle2"
                color="text.primary"
                fontWeight={600}
              >
                COUNT
              </Typography>
            </Box>

            <Divider />

            {data?.statusCounts.map((item) => (
              <Box key={`${item.status}-${item.locationType ?? ''}`}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  gap={2}
                  py={1.5}
                >
                  <Typography variant="body2" color='primary.main' fontWeight={600}>
                    {getStatusLabel(item.status)}
                  </Typography>

                  <Typography fontWeight={600}>{item.count}</Typography>
                </Box>

                <Divider />
              </Box>
            ))}

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mt={2}
            >
              <Typography variant="subtitle1" fontWeight={700} color='primary.main'>
                Total
              </Typography>

              <Typography variant="subtitle1" fontWeight={700}>
                {data?.total ?? 0}
              </Typography>
            </Box>
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuickViewDialog;
